export const postgresqlQueryKeys = {
  cnpg: ['cnpg'],
  details: ['details'],
  backups: ['backups'],
  cnpgDetails: (slug: string) => [
    ...postgresqlQueryKeys.cnpg,
    ...postgresqlQueryKeys.details,
    slug,
  ],
  cnpgBackups: (slug: string) => [
    ...postgresqlQueryKeys.cnpg,
    ...postgresqlQueryKeys.backups,
    slug,
  ],
};
